import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardSearchEmptyState = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    gap: "200",
    role: "status",
    "aria-live": "polite",
    paddingBlockEnd: "300",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "empty-state-charts",
      width: "64px"
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h6",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.searchEmptyState.header"
        })
      }), /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.searchEmptyState.body"
        })
      })]
    })]
  });
};
export default CardSearchEmptyState;